export { default } from './AboutCardSecondaryBenefitList';
